/* RESPONSIBLE TEAM: team-inbox-management */
import { type RenderableData } from 'embercom/objects/inbox/renderable-data';
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';
import { EntityType } from 'embercom/models/data/entity-types';
import DuplicateConversationSummary, {
  type DuplicateConversationSummaryWireFormat,
} from 'embercom/objects/inbox/duplicate-conversation-summary';
import AdminSummary, { type AdminSummaryWireFormat } from 'embercom/objects/inbox/admin-summary';

interface DuplicateConversationNoteWireFormat {
  renderable_type: RenderableType;
  duplicate_conversation_summaries: DuplicateConversationSummaryWireFormat[];
  entity: AdminSummaryWireFormat;
  company_name?: string;
}

export default class DuplicateConversationNote implements RenderableData {
  readonly renderableType: RenderableType = RenderableType.DuplicateConversationNote;
  readonly duplicateConversationSummaries: DuplicateConversationSummary[];
  readonly entity: AdminSummary;
  readonly companyName?: string;

  get isCompanyLevel(): boolean {
    return this.companyName != null;
  }

  get creatingEntity() {
    return { type: EntityType.Bot, id: this.entity.id, object: this.entity };
  }

  get styles() {
    return {
      backgroundColor: 'bg-notice-container',
      textColor: 'text-default',
      backgroundColorHover: 'bg-notice-container-emphasis',
    };
  }

  get ticketStyles() {
    return {
      backgroundColor: 'bg-transparent',
      textColor: 'text-default',
      backgroundColorHover: 'bg-neutral-container',
    };
  }

  constructor(
    duplicateConversationSummaries: DuplicateConversationSummary[],
    entity: AdminSummary,
    companyName?: string,
  ) {
    this.duplicateConversationSummaries = duplicateConversationSummaries;
    this.entity = entity;
    this.companyName = companyName;
  }

  static deserialize(json: DuplicateConversationNoteWireFormat): DuplicateConversationNote {
    let duplicateConversationSummaries = json.duplicate_conversation_summaries.map(
      (duplicate_conversation_summary: DuplicateConversationSummaryWireFormat) =>
        DuplicateConversationSummary.deserialize(duplicate_conversation_summary),
    );
    return new DuplicateConversationNote(
      duplicateConversationSummaries,
      AdminSummary.deserialize(json.entity),
      json.company_name,
    );
  }
}
